import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePicketSupplementSupplyContext from "../../hooks/usePicketSupplementSupplyContext";
import { Creators as AppActions } from "../../store/ducks/app";
import { Creators as ReportActions } from "../../store/ducks/report";

import { Col, Icon, Row } from "antd";
import { CardCustom, Title } from "./styles";

import ButtonStandard from "../../components/utils/button";
import DrawerPicketSupplyForecast from "../../components/drawers/picketSupplyForecast";
import { GenerateReport } from "../lot/listProduction/styles";
import PicketSupplementSupplyTable from "./table";
import PicketSupplementSupplyTableDashboard from "./dashboard";

function PicketSupplementSupplyLayout() {
  const dispatch = useDispatch();

  const { translation } = useSelector((state) => state.app);
  const { openDrawer, refreshData } = usePicketSupplementSupplyContext();
  const [isForecastDrawerVisible, setIsForecastDrawerVisible] = useState(false);

  function handleRefresh() {
    refreshData();
  }

  function handleCreateNewRecord() {
    openDrawer();
  }

  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between" align="middle">
        <Col span={8}>
          <Title>{translation.picketSupplementSupply.title}</Title>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <PicketSupplementSupplyTableDashboard />
        </Col>
      </Row>
      <Row
        className="rowHeader"
        justify="space-between"
        align="middle"
        style={{ margin: "16px 0" }}
      >
        <Col span={6}>
          <ButtonStandard
            type="button"
            buttonType="alternative"
            onClick={() => setIsForecastDrawerVisible(true)}
          >
            <Icon type="edit" />
            {translation.picketSupplyForecast.buttonOpen}
          </ButtonStandard>
        </Col>
        <Col span={18}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={handleRefresh}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <GenerateReport
              onClick={() =>
                dispatch(
                  ReportActions.showModal("ReportNutritionalConsumption")
                )
              }
            >
              Tratos/Consumo de Ração/Suplemento
            </GenerateReport>
            <Col>
              <GenerateReport
                onClick={() =>
                  dispatch(
                    ReportActions.showModal("ReportPicketFeedingAssessment")
                  )
                }
              >
                Planilha de Fornecimento
              </GenerateReport>
            </Col>
            <Col>
              <ButtonStandard
                type="button"
                buttonType="alternative"
                onClick={() =>
                  dispatch(
                    AppActions.showModalPicketSupplementSupplyAndFeedReaderUpload()
                  )
                }
              >
                <Icon type="upload" />
                {
                  translation.importPicketSupplementSupplyAndFeedReader
                    .buttonImport
                }
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                name="buttonCreateBudget"
                buttonType="addNew"
                onClick={handleCreateNewRecord}
              >
                {translation.picketSupplementSupply.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <PicketSupplementSupplyTable />
        </Col>
      </Row>
      <DrawerPicketSupplyForecast
        visible={isForecastDrawerVisible}
        onClose={() => setIsForecastDrawerVisible(false)}
      />
    </CardCustom>
  );
}

function PicketSupplementSupply() {
  return <PicketSupplementSupplyLayout />;
}

export default PicketSupplementSupply;
